import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface StatsTilesRowProps {
  children: ReactNode;
}

const StatsTilesRow = ({ children }: StatsTilesRowProps) => {
  return <TilesRowWrapper>{children}</TilesRowWrapper>;
};

export default StatsTilesRow;

const TilesRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 24px;
`;
